// extracted by mini-css-extract-plugin
export default {"Approved":"Status_Approved__Gt3Hk","Denied":"Status_Denied__wOA8v"};